import React from 'react';
import Icon from '../AppIcon';

const LoadingOverlay = ({ 
  isVisible = false, 
  message = 'Loading...', 
  progress = null,
  onCancel = null,
  type = 'default' // 'default', 'import', 'processing'
}) => {
  if (!isVisible) return null;

  const getLoadingIcon = () => {
    switch (type) {
      case 'import':
        return 'Upload';
      case 'processing':
        return 'Cog';
      default:
        return 'Loader2';
    }
  };

  const getLoadingMessage = () => {
    switch (type) {
      case 'import':
        return message || 'Importing member data...';
      case 'processing':
        return message || 'Processing data...';
      default:
        return message;
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-card rounded-lg shadow-deep p-8 max-w-sm w-full mx-4">
        <div className="flex flex-col items-center text-center">
          {/* Loading Icon */}
          <div className="mb-4">
            <Icon 
              name={getLoadingIcon()} 
              size={48} 
              className={`text-primary ${type === 'default' ? 'animate-spin' : 'animate-gentle-pulse'}`}
            />
          </div>

          {/* Loading Message */}
          <h3 className="text-lg font-medium text-foreground mb-2">
            {getLoadingMessage()}
          </h3>

          {/* Progress Bar */}
          {progress !== null && (
            <div className="w-full mb-4">
              <div className="flex justify-between text-sm text-muted-foreground mb-1">
                <span>Progress</span>
                <span>{Math.round(progress)}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          )}

          {/* Additional Info */}
          {type === 'import' && (
            <p className="text-sm text-muted-foreground mb-4">
              Please don't close this window while importing
            </p>
          )}

          {/* Cancel Button */}
          {onCancel && (
            <button
              onClick={onCancel}
              className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground border border-border rounded-md hover:bg-muted transition-colors duration-200 contextual-fade"
            >
              Cancel
            </button>
          )}

          {/* Loading Dots Animation */}
          <div className="flex space-x-1 mt-4">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;